export default class Hero {
    constructor(titles,contents,buttonContents,image,buttonUrl,isHome,isGallery) {
        this.titles = titles;
        this.contents = contents;
        this.buttonContents = buttonContents;
        this.image = image;
        this.buttonUrl = buttonUrl;
        // this.isHome = isHome;
        // this.isGallery = isGallery;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; } }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; } }
        for (const [key, value] of Object.entries(this.buttonContents)) { if(!value) { result = false; break; } }

        if(result) result = this.image && this.buttonUrl
        // if(result) result = this.image && this.buttonUrl && this.isHome && this.isGallery;

        return result;
    }
}